<section aria-label="ToolBar" tabindex="-1" class="heading-main-section" *ngIf="!isFullPageRoute" [ngStyle]="{'padding-top.px': sideBarHeight}">
  <div class="heading-main-div">
    <div class="d-flex justify-content-between">
      <div class="right-6 flex-1">
        <div class="right-heading-main-box">
          <button *ngIf="getBackBtn()" (click)="navigateBack()" class="btn btn-icon px-1" title='Go Back'>
            <lucide-angular name="arrow-left" [size]="20" aria-hidden="true"></lucide-angular>
          </button>
          <button (click)="refreshContent()" *ngIf="isButtonVisible()" title="Refresh" class="btn btn-icon px-1">
            <lucide-angular name="refresh-cw" [size]="18" aria-hidden="true"></lucide-angular>
          </button>
          <div
            *ngIf="canSearch"
            role="search"
            aria-label="Page"
            tabindex="-1"
            class="search-box-right"
          >
            <div class="search-div search-hover-div">
              <div
                class="search-box"
                [ngClass]="isSearchVisible ? 'full-width-input' : ''"
              >
                <input
                  id="page-search-input"
                  type="text"
                  value="{{ search }}"
                  [placeholder]="
                    searchService.disabled
                      ? 'Search is not available'
                      : 'Search...'
                  "
                  (keyup)="setSearch($event)"
                  (keyup.enter)="searchText()"
                  class="form-control form-search w-100"
                  [attr.disabled]="searchService.disabled ? 'True' : null"
                  aria-label="Search"
                  #input
                />
                <button
                  (click)="searchText()"
                  aria-label="Search Button"
                  class="btn btn-default btn-search"
                  id="search-box-inner-form"
                  [attr.disabled]="searchService.disabled ? 'True' : null"
                >
                  <div class="d-flex align-items-center">
                    <lucide-angular name="x" [size]="16" class="icon-search-cancel" aria-hidden="true"></lucide-angular>
                    <lucide-angular name="search" [size]="18" aria-hidden="true"></lucide-angular>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="btn-group-div btn-group justify-content-end">
            <i
              [class]="buttonText"
              style="font-size: 35px;"
              *ngIf="isDropdown && isIcon &&  (isAdminOrSuperAdmin() || isAuthorizedParticipant('dropDownDots'))"
              [ngStyle]="{
                color: 'black'
              }"
              ngbDropdownToggle>
            </i>
            <app-button
              *ngIf="
                isDropdown &&
                buttonText &&
                !isIcon &&
                (isAdminOrSuperAdmin() || isAuthorizedParticipant(''))
              "
              [isDropdown]="true"
              [title]="buttonText"
              color="blue"
              class="mr-2"
            ></app-button>
            <app-button
              *ngIf="isSecondButton && isAdminOrSuperAdmin()"
              [style]="'secondary'"
              [title]="secondButtonText"
              color="blue"
              (onClick)="selectComponent()"
              class="mr-2"
            ></app-button>
            <app-button
              *ngIf="
                !isDropdown &&
                buttonText &&
                buttonText != 'Add Audit Log' &&
                (isAdminOrSuperAdmin() || isAuthorizedParticipant('addRecord'))
              "
              [title]="buttonText"
              color="blue"
              class="mr-2"
              (onClick)="openModal()"
            ></app-button>
            <div
              *ngIf="isAdminOrSuperAdmin() || isAuthorizedParticipant('') || isAuthorizedParticipant('dropDownDots')"
              ngbDropdownMenu
              class="dropdown-menu dropdown-menu-right dropdown-menu-container"
              style="max-height: calc(100vh - 100px); overflow: auto;"
            >
              <ng-component
                *ngTemplateOutlet="loadDropdownTemplate()"
              ></ng-component>
            </div>
            <a
              *ngIf="getAppId() && isAdminOrSuperAdmin()"
              routerLink="/apps/{{ getAppId() }}/settings/user-management/roles/"
              class="btn btn-link-icon btn-settings"
              aria-label="Settings"
            >
              <lucide-angular name="settings" [size]="20" class="header-icons" aria-hidden="true"></lucide-angular>
            </a>
            <a
              *ngIf="isHelpWidgetShow"
              title="Open Help"
              tabindex="0"
              (click)="openSupport()"
              (keydown.enter)="openSupport()"
              class="btn btn-link-icon btn-settings"
              role="button"
              aria-label="Open Help"
            >
              <lucide-angular name="circle-help" [size]="20" class="header-icons"
                [ngStyle]="{ color: !isHelpWidget ? '' : 'var(--opengov-primary-blurple-lite)' }"
                aria-hidden="true"></lucide-angular>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-breadcrums
    *ngIf="hideBreadCrumb"
    class="p-10-v left-6 d-flex align-items-center"
  ></app-breadcrums>
</section>

<!-- Template to be loaded in case of Add report button -->
<ng-template #addReport>
  <ul>
    <li *ngFor="let item of addReportTemplateList" class="header-dropdown-item">
      <a
        class="d-flex align-items-center"
        [routerLink]="generateReportLink(item.link)"
      >
        <div class="img">
          <img [src]="'assets/images/icons/' + item.icon" alt=""/>
        </div>
        <div class="info">
          <h3>
            <a ngbDropdownItem>{{ item.title }}</a>
          </h3>
          <p>
            {{ item.description }}
          </p>
        </div>
      </a>
    </li>
  </ul>
</ng-template>
<!-- Template to be loaded in case of Add User -->
<ng-template #addUser>
  <ul>
    <ng-container *ngFor="let item of addUserTemplateList">
      <!-- For non-OG entities: Show "Add User" (wizard) and "Create User" (modal) -->
      <li *ngIf="!entityFriendlyId && (item.opType === 'ADD_USER_WIZARD' || item.opType === 'CREATE_USER')"
          class="header-dropdown-item">
        <a
          *ngIf="item.opType === 'ADD_USER_WIZARD'"
          ngbDropdownItem
          (click)="navigateToAddUserWizard()"
        >{{ item.title }}</a
        >
        <a
          *ngIf="item.opType === 'CREATE_USER'"
          ngbDropdownItem
          (click)="openModal(item.opType)"
        >{{ item.title }}</a
        >
      </li>
      <!-- For OG entities: Show "Create User in Control Panel" link -->
      <li *ngIf="entityFriendlyId && item.opType === 'CREATE_USER_IN_CONTROL_PANEL'" class="header-dropdown-item">
        <a
          ngbDropdownItem
          [href]="controlPanelURL + '/access/' + entityFriendlyId + '/users'"
          target="_blank"
          rel="noopener"
        >{{ item.title }}</a
        >
      </li>
    </ng-container>
  </ul>
</ng-template>

<!-- Template to be loaded in case of Add Pages and Dashboards -->
<ng-template #addPageDashboard>
  <ul>
    <ng-container *ngFor="let item of addPageDashboardTemplateList">
      <li
        *ngIf="isAddItemVisible(item)"
        class="header-dropdown-item"
      >
        <a
          [routerLink]="!item.isModal ? generateDashboardLink(item.link) : null"
          ngbDropdownItem
          (click)="item.isModal ? openModal(item.opType) : null"
        >{{ item.title }}</a
        >
      </li>
    </ng-container>
  </ul>
</ng-template>

<!-- Template to be loaded in case of Add form button -->
<ng-template #addForm>
  <ul>
    <li *ngFor="let item of addFormTemplateList" class="header-dropdown-item">
      <a
        class="d-flex align-items-center"
        [routerLink]="generateReportLink(item.link)"
      >
        <div class="img">
          <img [src]="'assets/images/icons/' + item.icon" alt=""/>
        </div>
        <div class="info">
          <h3>
            <a ngbDropdownItem>{{ item.title }}</a>
          </h3>
          <p>
            {{ item.description }}
          </p>
        </div>
      </a>
    </li>
  </ul>
</ng-template>

<!-- Template to be loaded in case of Add Notification button -->
<ng-template #addNotification>
  <ul>
    <li *ngFor="let item of addNotificationTemplateList" class="header-dropdown-item">
      <a
        class="d-flex align-items-center"
        [routerLink]="generateReportLink(item.link)"
      >
        <div class="img">
          <img [src]="'assets/images/icons/' + item.icon" alt=""/>
        </div>
        <div class="info">
          <h3>
            <a ngbDropdownItem>{{ item.title }}</a>
          </h3>
          <p>
            {{ item.description }}
          </p>
        </div>
      </a>
    </li>
  </ul>
</ng-template>

<ng-template #editRecord>
  <ul>
    <ng-container *ngFor="let item of editRecordTemplateList">
      <ng-container *ngIf="getItemCondition(item.link)">
        <li
          *ngIf="!item.conditional || (item.conditional && !isEditForm)"
          class="header-dropdown-item"
          (keyup)="$event.preventDefault()"
          (click)="performViewRecordOperation(item.link)">
          <a ngbDropdownItem>{{ item.title }}</a>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</ng-template>

<ng-template #addRecord>
  <ul>
    <ng-container *ngFor="let item of addRecordTemplateList">
      <li *ngIf="getItemCondition(item.link)" class="header-dropdown-item">
        <a
          ngbDropdownItem
          (click)="performViewRecordOperation(item.link)"
        >{{ getAddRecordtext(item) }}</a
        >
      </li>
    </ng-container>
  </ul>
</ng-template>

<ng-template #editUserInterface>
  <ul>
    <ng-container *ngFor="let item of editUserInterfaceTemplateList">
      <li *ngIf="isItemVisible(item.link)" class="header-dropdown-item">
        <a
          ngbDropdownItem
          (click)="performUserInterfaceroute(item.link)"
        >{{ item.title }}</a
        >
      </li>
    </ng-container>
  </ul>
</ng-template>

<ng-template #profileTemplate>
  <div class="user-info">
    <h3>{{ fullName() }}</h3>
    <p>{{ email() }}</p>
  </div>
  <ul>
    <li>
      <a
        class="dropdown-item ml-1"
        routerLink="/user/profile"
      >
        <span class=" icon-edit-2"></span>
        <span class="text ml-3">Edit Profile</span></a
      >
    </li>
    <li>
      <a class="dropdown-item ml-1" routerLink="/apps">
        <span class="icon-apps" aria-hidden="true"></span>
        <span class="text ml-3">Apps</span></a
      >
    </li>
    <li *ngIf="isSuperAdmin && !isImpersonate">
      <a class="dropdown-item" routerLink="/company">
        <span class="common-icon icon-person"></span>
        <span class="text">Account Manager</span></a
      >
    </li>
    <li *ngIf="isBillingAdmin">
      <a class="dropdown-item profile-icons" [routerLink]="'/company/'+companyId">
        <span class="common-icon icon-person"></span>
        <span class="text ml-3">Company Details</span></a
      >
    </li>
    <li *ngIf="isBillingAdmin">
      <a class="dropdown-item profile-icons" routerLink="/user/billing">
        <span class="common-icon icon-person"></span>
        <span class="text ml-3">Billing Admin</span></a
      >
    </li>
    <li *ngIf="isSuperAdmin && !isImpersonate">
      <a class="dropdown-item profile-icons ml-1" routerLink="/clients">
        <span class="icon-people" aria-hidden="true"></span>
        <span class="text ml-3">Manage Clients</span></a
      >
    </li>
    <li *ngIf="isSuperAdmin && !isImpersonate">
      <a class="dropdown-item ml-1" (click)="executeTodayFormulas()">
        <i class="common-icon icon-restart"></i>
        <span class="text ml-3">Run Today Formulas</span></a
      >
    </li>
    <li *ngIf="isHelpWidgetShow">
      <a
        href="https://support.opengov.com/"
        target="_blank"
        class="dropdown-item"
      >
        <i class="common-icon icon-help"></i>
        <span class="text ml-3">Help</span></a
      >
    </li>
    <li *ngIf="!isImpersonate" class="logout-li">
      <a (click)="logout()" class="dropdown-item profile-icons ml-1">
        <span class="common-icon icon-logout"></span>
        <span class="text ml-3">Logout</span></a
      >
    </li>
    <li *ngIf="isImpersonate" class="logout-li">
      <a
        (click)="restoreSuperAdmin()"
        class="dropdown-item profile-icons"
      >
        <span class="common-icon icon-refresh"></span>
        <span class="text ml-3">End Impersonate User</span></a
      >
    </li>
  </ul>
</ng-template>
